import _ from 'lodash'
import moment from 'moment'
import { isEmpty } from 'oderon-commons/src/utils'

export function toHex(n, minDigits = 0) {
  var s = n.toString(16)
  if (s.length % 2 != 0) s = '0' + s
  return _.padStart(s, minDigits, '0')
}

export function isSameDay(a, b) {
  // junta os nulls no grupo anterior
  if (a == null || b == null) return true
  return moment(a).isSame(b, 'day')
}

export function groupByDay(items, propName) {
  propName = propName || 'startTimestamp'

  var result = []
  items.forEach(function(i) {
    var last = _.last(result),
      timestamp = _.get(i, propName)

    // junta nulls no grupo anterior
    if (last == null || !isSameDay(timestamp, last.timestamp)) {
      last = { timestamp: timestamp, items: [i] }
      result.push(last)
    } else {
      last.items.push(i)
      if (last.timestamp == null) last.timestamp = timestamp
    }
  })

  return result
}

export function s2a(s) {
  if (s == null) return null
  if (_.isArray(s)) return s
  if (s.trim().length < 1) return null
  return s.split(',').map((p) => p.trim())
}

export function mergeQuery(router, route, newQ) {
  let oldQ = route.query
  newQ = _.assign(
    {},
    oldQ,
    _.mapValues(newQ, (v) => encodeValue(v))
  )
  router.replace({ query: newQ })
}

export function encodeValue(v) {
  if (v == null) return null

  if (_.isArray(v)) {
    if (v.length < 1) return null
    return v.join(',')
  }

  if (_.isString(v)) {
    if (_.isEmpty(v)) return null
    return v.trim()
  }

  if (_.isDate(v) || moment.isMoment(v)) {
    return moment(v).format()
  }

  return v
}

export function join(b, p) {
  if (b == null || b.length < 1) return p
  if (p == null) return b
  if (p[0] == '/') return b + p
  else return b + '/' + p
}

export function isBlank(s) {
  return s == null || s.trim().length < 1
}

export function sod(dt, n = 0) {
  return moment(dt || undefined)
    .add(n, 'd')
    .startOf('d')
    .toDate()
}

export function letters(s) {
  if (s == null) return null
  return _.deburr(s)
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
}

export function matchLetters(needle, str) {
  if (isBlank(needle)) return true
  return letters(needle).indexOf(letters(str)) != -1
}

export function matchAny(needle, ...values) {
  if (isBlank(needle)) return true
  needle = letters(needle)
  values = _.chain(values)
    .flatten()
    .compact()
    .value()
  return _.some(values, (v) => letters(v).indexOf(needle) != -1)
}

// Uso:
// hasTag(vehicle, 'EmAfericao')
// hasTag(vehicle.get('tags'), 'EmAfericao')
// hasTag(['tag1'], 'EmAfericao')
//
// A verificação leva em conta apenas letras/números,
// ou seja, EmAferição == em-afericao
export function hasTag(obj, tag) {
  if (obj == null) return false

  var tags = []
  if (_.isArray(obj)) tags = obj
  else if (obj.get) tags = obj.get('tags')
  else if (obj.tags) tags = obj.tags

  tag = letters(tag)

  return _.some(tags, (t) => letters(t) == tag)
}

export function dec(x) {
  return x ? x.toLocaleString() : '-'
}

const _m = 60,
  _h = 60 * _m,
  _d = 24 * _h,
  _M = 30 * _d,
  _y = 12 * _M

export function smallTimeago(dt) {
  if (dt == null) return ''

  let d = moment().diff(dt, 's'),
    f = Math.floor

  if (d < _m) return d + 's'
  if (d < _h) return f(d / _m) + 'm'
  if (d < _d) return f(d / _h) + 'h'
  if (d < _M) return f(d / _d) + 'd'
  if (d < _y) return f(d / _M) + 'M'
  return f(d / _y) + 'A'
}

// úteis para validação
export function required(x) {
  return !!x || 'Obrigatório'
}

export function notNone(x) {
  return x != -1 || 'Não pode ser NONE'
}

export function isInt(x) {
  let ok = x != null && x.toString().match(/\d+/)
  if (!ok) return 'Precisa ser um número'
  return true
}

export function anyEmpty(...x) {
  return x.some((y) => isEmpty(y))
}

export function any0(...x) {
  return x.some(y => y === 0)
}

export function sanitizeTechName(x) {
  if ( x == null ) return x
  return x.replace(/Autorizado Oderon/, 'Aut.Od.')
}